import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=349736ed&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=349736ed&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349736ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconSearch: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/dynamic/IconSearch.vue').default,SvgIconCross: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCross.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default,SearchSuggestionList: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchSuggestionList.vue').default,SearchProductList: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchProductList.vue').default,SearchBlogList: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchBlogList.vue').default,AppContainer: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppContainer.vue').default})
